/**
 * Отрывное поле по краю строки.
 *
 * Полоса тихая. Смысл — значком того же кегля, что старая кнопка «окном»,
 * и только по наведению: иначе снова колонка глифов. Слева булавка (держать),
 * справа окно. Пунктир справа сняли: на сотне строк он читался дешёвой кромкой.
 *
 * Принято на labs (24.08, владелец) и перенесено на боевой `/app`: скрепка
 * слева и квадрат «окном» спорили с цифрами так же, как на сотне строк.
 */

import { toggleClip } from './clip';

export function Coupon({
  kind,
  id,
  on = false,
  onPop,
}: {
  kind: 'pin' | 'pop';
  id: string;
  on?: boolean;
  onPop?: (id: string) => void;
}): React.ReactElement {
  const pin = kind === 'pin';
  const title = pin
    ? on
      ? 'убрать калькулятор'
      : 'в калькулятор'
    : 'открыть вилку отдельным окном';
  return (
    <button
      type="button"
      className={`nx-fk__coupon nx-fk__coupon--${kind} ${pin ? 'nx-fk__clip' : 'nx-fk__pop'}`}
      aria-pressed={pin ? on : undefined}
      aria-label={pin ? title : 'открыть отдельным окном'}
      title={title}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        if (pin) toggleClip(id);
        else onPop?.(id);
      }}
    >
      <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        {pin ? (
          <>
            {/* Шприц из прямых, зеркало по x=8. Старый контур с «ушками»
                (5.4 / 6.5 11.2) на 17 px читался кривым (24.08, владелец). */}
            <path d="M6 2.5h4v4H6Z" />
            <path d="M4 6.5h8" />
            <path d="M8 6.5v8" />
          </>
        ) : (
          <>
            <path d="M6.5 3.5h-3v9h9v-3" />
            <path d="M9.5 3.5h3v3" />
            <path d="M12.5 3.5 7.5 8.5" />
          </>
        )}
      </svg>
    </button>
  );
}
